// extracted by mini-css-extract-plugin
export default {"input":"JoinLesson_input_cWBpZ","button":"JoinLesson_button_BmQGX"};